import * as React from 'react';
import { useSelector } from 'react-redux';

import { PageLoader } from '../../components/PageLoader';
import { selectIsPageLoaderVisible } from '../../selectors/loading';

export const PageLoaderContainer: React.FC = () => {
  const isPageLoaderVisible = useSelector(selectIsPageLoaderVisible);

  if (isPageLoaderVisible) {
    return <PageLoader />;
  }

  return null;
};
